import './delay_render_chart_view.js.coffee';# Added by Script 
import './chart_view.js.coffee'
Namespace 'CustomerVisualMode.Charts'

CHARTS = CustomerVisualMode.Charts

class CustomerVisualMode.Charts.BotCheckpointsChartView extends CustomerVisualMode.Charts.DelayRenderChartView
  template: JST['backbone/templates/customer_visual_mode/charts/bot_checkpoints_chart']
  className: 'grid-item full-width-chart bot-checkpoints'
  @NAME: 'bot_checkpoints'

  initialize: ({widget, data, session, isReadOnly, isResponsive}) ->
    @barMenu = new Common.Dashboard.Charts.BarMenuView(exportable: true)
    title = I18n.t('customer_visual_mode.charts.bot_checkpoints.title')
    description = I18n.t('customer_visual_mode.charts.bot_checkpoints.description')
    super({widget, title, description, data, session, isReadOnly, isResponsive})

  render: ->
    super()
    @$el.find('.chart').html(@template)
    @checkpointsView = @_checkpointsMetricsView()
    @listenTo(@checkpointsView, 'ColumnGraph:click:column', @_openDrilldown)
    @$el.find('.checkpoints-metrics').append(@checkpointsView.render().el)
    @$el.find('.title').addClass('bot-checkpoints-widget-title')
    @$el.find('.chart-actions').children().last().before(@barMenu.render().el)
    @

  _checkpointsMetricsView: ->
    new CustomerVisualMode.Charts.ColumnGraphChartView({graphData: @_formatDataForColumnGraph()})

  _renderChart: =>
    @chart = @checkpointsView.renderChart()
    @barMenu.chart = @chart
    @chart

  _formatDataForColumnGraph: =>
    _.map(@data.checkpoint_count, (checkpointData) ->
      checkpointName = Object.keys(checkpointData)[0]
      {x: checkpointName, y: checkpointData[checkpointName]}
    ).sort((a, b) -> b.y - a.y)

  _openDrilldown: (drilldownValue) =>
    data = {
      dimensions: ['chatbot_checkpoints'],
      checkpoint_name: drilldownValue,
      name: drilldownValue,
      drilldown_code: 'created_conversations',
      timezone: moment().format('Z')
    }
    super(data)
